$(document).ready(function(){

  $('.js-back-to-top').on('click', function(){
    $('html, body').animate({
      scrollTop: '0px'
    }, 500);
  })
});
